import { Badge, Empty, Popover, Space } from "antd";
import React from "react";
import {
  agency,
  cartIcon,
  emptyImgae,
  logoHeader,
  searchIcon,
} from "../../assets";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useGetSearchParams from "../../hooks/useGetSearchParams";
import useCurrentApiPos from "../../hooks/useCurrentApiPos";
import { dataCartAction, dataCartInfo } from "../../slices/dataCartSlice";
import Lang from "../Lang";
import "./index.scss";

const Header = () => {
  const navigate = useNavigate();
  const dataCountCart = useSelector(dataCartInfo);
  const brandId = useGetSearchParams("brandId");
  const dateStart = useGetSearchParams("start_date");
  const dispatch = useDispatch();
  const pathname = useLocation().pathname;
  const { t } = useTranslation();
  const user_agency = JSON.parse(sessionStorage.getItem("user_agency") || "{}");

  const handleClickFunc = (redirect) => {
    // if (redirect == 'lookup') return
    switch (redirect) {
      case "cart":
        navigate(
          `/select_step/cart?brandId=${brandId}&start_date=${dateStart}`,
        );
        break;
      case "lookup":
        navigate(`/ticket/look_up?brandId=${brandId}&start_date=${dateStart}`);
        break;
      case "login":
        navigate(`/login`);
        break;
    }
  };

  const handleBackHome = () => {
    dispatch(dataCartAction.setCountCart(0));
    dispatch(dataCartAction.setDataCart([]));
    navigate(`/`);
  };
  // const envKey = brandId
  //   ? "REACT_APP_BRAND_" + brandId.trim().toUpperCase()
  //   : "";
  // const paramsUrl = window.env.REACT_APP_BASE_URL;
  const currentApiPos = useCurrentApiPos();

  const content = () => {
    return dataCountCart.dataCart.length > 0 ? (
      <div className="header__notify">
        <div div className="header__notify--title">
          {t("productAdded")}
        </div>
        <ul className="header__notify--list">
          {dataCountCart.dataCart.map((item, i) => {
            return (
              <li className="header__notify--item">
                <a className="header__notify--link" href="#">
                  <img
                    src={
                      currentApiPos + "/assets/images/product/" + item.imagePath
                    }
                    alt=""
                    className="header__notify--img"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = emptyImgae;
                    }}
                  />
                  <div className="header__notify--info">
                    <p className="header__notify--name">{item.nameProduct}</p>
                    <p
                      className="header__notify--description"
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    ></p>
                    <div className="header__notify--price">
                      <span>₫{Intl.NumberFormat().format(item.amount)}</span>
                      <span>x{item.count}</span>
                    </div>
                  </div>
                </a>
              </li>
            );
          })}
        </ul>
        <div
          onClick={() => handleClickFunc("cart")}
          className="view-to-cart-page"
        >
          {t("titleViewAll")}
        </div>
      </div>
    ) : (
      <Empty />
    );
  };

  return (
    <div className="header">
      <div className="header__logo">
        <span onClick={handleBackHome}>
          <img src={logoHeader} alt="" />
        </span>
      </div>

      <div className="header__action">
        <Space size={"middle"} align="center">
          {pathname !== "/" &&
          pathname !== "/login" &&
          pathname !== "/admin" ? (
            <>
              <div
                className="header__action--icon"
                onClick={() => handleClickFunc("lookup")}
              >
                <img src={searchIcon} alt="" />
                <span className="header__action--title">
                  {t("search_ticket")}
                </span>
              </div>
              <Popover
                placement="bottom"
                title={t("shopping_cart")}
                content={content}
              >
                <div className="header__action--icon">
                  <Badge count={dataCountCart.dataCart.length}>
                    <img src={cartIcon} alt="" />
                  </Badge>
                  <span className="header__action--title">
                    {t("shopping_cart")}
                  </span>
                </div>
              </Popover>
              <div
                className="header__action--icon only-mobile"
                onClick={() => handleClickFunc("cart")}
              >
                <Badge count={dataCountCart.dataCart.length}>
                  <img src={cartIcon} alt="" />
                </Badge>
                <span className="header__action--title">
                  {t("shopping_cart")}
                </span>
              </div>
            </>
          ) : null}
          {pathname !== "/login" ? (
            user_agency.companyName ? (
              <Popover
                placement="bottom"
                key={"logout"}
                content={
                  <a
                    onClick={() => {
                      sessionStorage.clear();
                      navigate("/");
                    }}
                  >
                    Đăng Xuất
                  </a>
                }
              >
                <div className="header__action--icon">
                  <img src={agency} alt="" />
                  <span className="header__action--title2">
                    {user_agency.companyName}
                  </span>
                </div>
              </Popover>
            ) : (
              <div
                className="header__action--icon"
                onClick={() => handleClickFunc("login")}
              >
                <img src={agency} alt="" />
                <span className="header__action--title2">
                  {user_agency.companyName
                    ? user_agency.companyName
                    : t("login_agency")}
                </span>
              </div>
            )
          ) : null}
          <div className="header__action--icon header__action--lang">
            <Lang />
          </div>
        </Space>
      </div>
    </div>
  );
};

export default Header;
